/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { BlockTypes } from "../Constants/BlockTypes";
import { HtmlAttributes } from "../../../../Common/Constants/HtmlAttributes";
import { findAttributeInFieldBlock, findCheckboxes, findFieldBlocksOfType, isFieldBlockRequired } from "../Utils/HtmlUtils";
import { ValidationUtils } from "../Utils/ValidationUtils";
var MultiSelectValidator = /** @class */ (function () {
    function MultiSelectValidator() {
        var _this = this;
        this.onCheckboxValidate = function (form, checkboxes, config) {
            _this.validateMultiSelect(form, checkboxes, config, true);
        };
    }
    MultiSelectValidator.prototype.attachValidation = function (form, config) {
        var _this = this;
        findFieldBlocksOfType(form, BlockTypes.blockTypeMultiSelect).forEach(function (block) {
            _this.attachValidationHandlersMultiSelect(form, block, config);
        });
    };
    MultiSelectValidator.prototype.validateMultiSelect = function (form, allCheckboxes, config, displayAccessibleError) {
        var _a;
        // clear validation
        var firstCheckbox = allCheckboxes[0];
        // remove accessible error element only for the first checkbox
        ValidationUtils.removeValidationError(form, firstCheckbox);
        // remove custom validation errors from all checkboxes
        allCheckboxes.forEach(function (checkbox) {
            ValidationUtils.setInputValid(checkbox);
        });
        // ensure at least one selected
        var selectedCheckboxes = Array.from(allCheckboxes).filter(function (c) { return c.checked; });
        if (!selectedCheckboxes.length) {
            // show the validation error on the first one
            var requiredErrorMessage_1 = (_a = findAttributeInFieldBlock(firstCheckbox, HtmlAttributes.errorMessage)) !== null && _a !== void 0 ? _a : config.fieldRequiredErrorMessage;
            // set custom validation error to all checkboxes
            allCheckboxes.forEach(function (checkbox) {
                ValidationUtils.setInputInvalid(checkbox, requiredErrorMessage_1);
            });
            if (displayAccessibleError) {
                // set accessible error element only for the first checkbox
                // using 'name' as the 'for' attribute for the label the text should be taken from
                ValidationUtils.addValidationError(form, firstCheckbox, requiredErrorMessage_1, firstCheckbox.name);
            }
        }
    };
    MultiSelectValidator.prototype.attachValidationHandlersMultiSelect = function (form, block, config) {
        var _this = this;
        if (!isFieldBlockRequired(block)) {
            return;
        }
        var checkboxes = findCheckboxes(block);
        if (checkboxes === null || checkboxes === void 0 ? void 0 : checkboxes.length) {
            this.validateMultiSelect(form, checkboxes, config, false);
            checkboxes.forEach(function (checkbox) {
                ValidationUtils.attachChangeEventHandler(checkbox, function () { return _this.onCheckboxValidate(form, checkboxes, config); });
                ValidationUtils.attachInvalidEventHandler(checkbox, function () { return _this.onCheckboxValidate(form, checkboxes, config); });
            });
        }
    };
    return MultiSelectValidator;
}());
export { MultiSelectValidator };
